<!-- 財務 -> 应收管理 -> 客户收款 -->
<template>
    <div class="templete">
        <div class="search_box clearfix">
            <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.salesman_id" multiple collapse-tags filterable placeholder="归属人:" @visible-change="getSalesman">
                <el-option v-for="list in salesmanList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="resetSearch">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert clearfix">
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="isInout&&module.indexOf(',finance-doc-receivable-customer,')!=-1" @click="batch">收款/付款</el-button>
            <el-button class="funcPublicBtn" @click="addArrearsFunc">添加期初欠款</el-button>
            <!-- add by xiong -->
            <el-button class="funcPublicBtn" @click="addSettle">结算欠款</el-button>
            <!-- ... -->
            <el-button class="funcPublicBtn" @click="addFirst">添加期初余额</el-button>
            <div class="contractLabel" style="position:relative;">
                <span class="redQuestion"></span>
                <div class="labelTip">
                    <div class="labelZhu">注:</div>
                    <div class="laCbelTipC">1.新用户在添加客户期初欠款时，请点"添加期初欠款"(可多次输入欠款，也可以单次删除并重新加)。客户还款时收款后，直接点"结算欠款"来平账。</div>
                    <div class="laCbelTipC">2.当客户有之前的预付款在公司账上时，请点"添加期初余额"，下次采购时可以直接结算。</div>
                    <div class="laCbelTipC">3.使用有不清楚的地方，请随时联系我们。</div>
                </div>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @sortTable="sortTable" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <!-- <div class="totalNumber">期初金额:{{totalObj.init_amount}}</div> --> 
            <div class="totalNumber">其它欠款:{{totalObj.debt}}</div>  
            <div class="totalNumber">客户余额:{{totalObj.balance}}</div>      
            <div class="totalNumber">未结欠款:{{totalObj.unbalance}}</div>
            <div class="totalNumber">客户总欠款:{{totalObj.debt_amount}}</div>
            
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 新增收款单 dialog START -->
        <el-dialog v-dialog-drag title="新增收款/付款单" :visible.sync="addDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称：">
                        <el-input  v-model="add_params.customer_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" placeholder="" @change="typeChange">
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder=""  @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="add_params.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->
        <!--添加期初START-->
        <el-dialog v-dialog-drag :visible.sync="initDialogVisible" class="eldialog eldialogLine deepStyle" width="285px" :modal="false" title="添加期初余额" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB" style="text-align: left">
                    <el-form-item  label="客户：">
                        <select-down-customer ref="selectdowncustomer" class="searchCustomer searchCustomerItem" @changeselect="res=>{this.initForm.customer_id = res;}"></select-down-customer>
                    </el-form-item>
                    <el-form-item  label="期初金额：">
                        <el-input v-model="initForm.balance"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" :rows="3" v-model="initForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol" style="padding-top: 50px">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveInit">添加保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加期初END-->
        <!--添加期初欠款 START-->
        <el-dialog v-dialog-drag :visible.sync="addArrearsDialogVisible" class="eldialog eldialogLine deepStyle" width="285px" :modal="false" title="添加期初欠款" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB" style="text-align: left">
                    <el-form-item  label="添加时间：">
                        <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="addArrearsTime"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="客户：">
                        <select-down-customer ref="selectdowncustomer" class="searchCustomer searchCustomerItem" @changeselect="res=>{this.addArrearsForm.customer_id = res;}"></select-down-customer>
                    </el-form-item>
                    <el-form-item  label="欠款金额：">
                        <el-input v-model="addArrearsForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" :rows="3" v-model="addArrearsForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol" style="padding-top: 50px">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveArrear">添加保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加期初欠款 END-->

        <!-- add by xiong -->
        <!-- 结算确认 dialog START -->
        <el-dialog v-dialog-drag title="结算欠款" :visible.sync="sureDialogVisible" width="500px" class="eldialog eldialogLine deepStyle" @close="settleClose" :model="false">
            <div class="dialogSearchBox">
                <el-form :model="sure_params" class="clearfix dialogFormB" style="text-align: left" ref="sure_form">
                    <el-form-item label="客户余额：" class="other_form_item">
                        <div style="text-align:left;">{{selectRow[0] ? selectRow[0].balance : 0}}</div>
                    </el-form-item>
                    <el-form-item label="结算RMB金额：" class="other_form_item">
                        <el-input v-model="sure_params.amount" @input="settlementInput" placeholder=""></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="备注：">
                        <el-input type="textarea" :rows="3" v-model="sure_params.remark"></el-input>
                    </el-form-item> -->
                    <div class="elFormBoxBtnListCol" style="padding-top: 50px">
                        <el-button  class="publicBtn funcPublicBtnChecked"  @click="settlement">确定结算</el-button>
                        <!-- <el-button class="dialogBtn funcPublicBtn" @click="sureDialogVisible = false">取消</el-button> -->
                    </div>
                    <!-- <div class="eldialogFormBox">
                    </div>
                    <div class="eldialogFormBox">
                    </div>
                    <textarea class="edit_input edit_textarea" v-model="sure_params.remark"></textarea> -->
                    <!-- <div class="dialogBtnList clearfix">
                        <el-button  class="publicBtn dialogBtn"  @click="settlement">确定</el-button>
                        <el-button class="dialogBtn funcPublicBtn" @click="sureDialogVisible = false">取消</el-button>
                    </div> -->
                </el-form>
            </div>
        </el-dialog>
        <!-- 结算确认 dialog END -->

        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleList" class="eldialog eldialogC no_print" width="830px" :modal="false" title="欠款添加记录" custom-class="full_dialog">
            <el-table :data="arrearList" border stripe highlight-current-row size="mini" height="100%">
                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="操作" width="50">
                    <template slot-scope="scope">
                        <i class="operation_delete" @click.stop="deleteF(scope.row.id)" title="删除"></i>
                    </template>
                </el-table-column>
                <el-table-column label="添加时间" width="90" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.add_time }}
                    </template>
                </el-table-column>
                <el-table-column label="添加人" width="135" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.creator_name }}
                    </template>
                </el-table-column>
                <el-table-column label="客户名称" width="135" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column label="金额" width="135" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.amount }}
                    </template>
                </el-table-column>
                <el-table-column label="备注" width="180" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.remark }}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- dialog END -->
    </div>
</template>
<style lang="scss" scoped>
.deepStyle /deep/ .el-textarea__inner{ padding: 5px; border-color: #a7a7a7;font-size: 12px;}
.deepStyle /deep/ .el-form-item{ margin-left: 0; width: 258px;}
.deepStyle /deep/ .el-form-item .el-form-item__content{width: 160px;}
.contractLabel{float: left;position: relative;top:10px;margin-left:10px;}
.path_title_name{float: left;}
.redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
.labelTip{display: none;position: absolute;top:20px;left:-150px;z-index:1;width:300px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
.laCbelTipC{color:#606266;font-size: 12px;margin-bottom:5px;font-weight: 600;}
.laCbelTipC:last-child{margin-bottom:0;}
.labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
.contractLabel:hover{cursor: pointer;}
.contractLabel:hover .labelTip{display: block;}
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    import selectDownCustomer from '../../components/selectDownCustomer.vue'
    export default {
        components:{
            pagination,
            tabletem,
            selectDownCustomer
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                trading_time : new Date(),
                addDialogVisible:false,
                initDialogVisible:false,
                addArrearsDialogVisible:false,
                dialogVisibleList:false,
                arrearList:[],
                add_params : {
                    order_id : "",
                    bill_type : 0,
                    amount : "",
                    account_id : "",
                    customer_id : "",
                    trading_time :"",
                    trading_mode_id : "",
                    course_title : "进销货款",
                    remark : ""
                },
                ruleForm:{
                    ids:[],
                    salesman_id:""
                },
                params:{
                    search:{
                        customer_id: "",
                        salesman_id:"",
                    },
                    field:"",
                    sort:"",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                list : [],
                selectMap:{
                    customer:[],
                    user:[],
                    account:[],
                    paymentType:[]
                },
                tableCol:[	
                    {colName:"客户名称",colKey:"name",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"期初金额",colKey:"init_balance",colWidth:100,isSetWidth:true,isCanClick:true,isHideShowClickImg:true,isHideCanClickColor:true,isShow:true,isSort:true}, //add by xiong
                    {colName:"其它欠款",colKey:"debt",colWidth:120,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isSort:true},
                    {colName:"客户余额",colKey:"balance",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"未结欠款",colKey:"unbalance",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"欠款总额",colKey:"debt_amount",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"归属人",colKey:"salesman_name",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"明细详情",colKey:"see",colWidth:120,isSetWidth:true,isCanClick:true,isShow:true}
                ],
                selectRow:[],
                isInout:false,
                initForm:{
                    customer_id: "",
                    balance: "",
                    remark: ""
                },
                addArrearsTime:new Date(),
                addArrearsForm:{
                    create_time:"",
                    customer_id:"",
                    amount:"",
                    remark:""
                },
                totalObj:{
                    balance:0,
                    unbalance:0,
                    debt_amount:0
                },
                sureDialogVisible: false,
                sure_params: {
                    amount: 0,
                    remark: '',
                    customer_id: ''
                },
                salesmanList:[],
                seeId:""
            }
        },
        created(){
            this.getSelectList("user")
            this.getSelectList("customer")
            this.getSelectList("account")
            this.getSelectList("paymentType")
            this.getList();
            this.getSalesman()
        },
        methods:{
            excelExport(){
                this.$exportExecl("/erp/export.customer.receivables","客户应收",this.params)
            },
            addArrearsFunc(){
                if(this.selectRow.length==1){
                    this.addArrearsForm.customer_id = this.selectRow[0].id;
                }
                this.addArrearsDialogVisible = !this.addArrearsDialogVisible;
            },
            deleteF(id){
                this.$confirm('是否确定删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/customer.delete.debt",{id:id},()=>{
                        this.tip("删除成功","success")
                        let obj = new Object();
                        obj.name = "debt";
                        obj.id = this.seeId;
                        this.rowClick(obj);
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            saveArrear(){
                this.addArrearsForm.create_time = this.formatTimeZero(this.addArrearsTime)
                this.postFuncLoading("/erp/customer.add.debt",this.addArrearsForm,()=>{
                    this.tip("添加成功","success")
                    this.addArrearsDialogVisible=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSalesman(){
                this.postFunc("/erp/customer.salesman.select",{},res=>{
                    this.salesmanList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addFirst(){
                this.initDialogVisible = !this.initDialogVisible;
                if(this.selectRow.length==1){
                    this.initForm.customer_id = this.selectRow[0].id;
                    this.initForm.balance = Number(this.selectRow[0].init_balance) >= 0 ? this.selectRow[0].init_balance:'';
                }
            },
            typeChange(val){
                this.pl(val)
                if(val==0){
                    this.add_params.course_title = "进销货款";
                }else{
                    this.add_params.course_title = "退货付款";
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            saveInit(){
                if(this.selectRow.length>0){
                    if(this.selectRow[0].init_balance > 0){
                        this.$confirm('修改期初余额，请谨慎操作。', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.saveInitConfirm()
                        }).catch(()=>{});
                    }else{
                        this.saveInitConfirm()
                    }
                }else{
                    this.saveInitConfirm()
                }
            },
            saveInitConfirm(){
                this.postFuncLoading("/erp/customer.balance.init",this.initForm,()=>{
                    this.tip("添加成功","success")
                    this.initDialogVisible=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addOrderSheet(){
                this.$confirm('是否确认收款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.order_id=0;
                    this.add_params.trading_time=parseInt(this.trading_time.getTime()/1000)
                    this.postFuncLoading("/erp/finance.inout",this.add_params,()=>{
                        this.tip("收款成功","success")
                        this.addDialogVisible=false;
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.postFunc("/erp/finance.customer",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.totalObj=res.data.data.statistic;
                    this.isInout=res.data.data.isInout;
                    this.list.forEach((item)=>{
                        item.see="明细详情";
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            batch(){
                if(this.selectRow.length<1||this.selectRow.length>1){
                    this.tip("请选择一条收款","warning")
                }else{
                    this.add_params.customer_id=this.selectRow[0].id;
                    this.add_params.customer_name=this.selectRow[0].name;
                    this.addDialogVisible=true;
                }
            },
            //modified by xiong
            rowClick(obj){              
                if(obj.name == "init_balance"){
                    this.list.forEach(item=>{
                        if(item.id == obj.id){
                            item.init_remark = item.init_remark == "" ? "未填写备注内容" : item.init_remark
                            this.$alert(item.init_remark, '备注', {
                                confirmButtonText: '关闭',
                                callback: action => {
                                window.console.log(action)
                                }
                            })
                        }
                    })                 
                }if(obj.name == "debt"){
                    this.seeId = obj.id;
                    this.postFuncLoading("/erp/customer.get.debts",{customer_id:obj.id},res=>{
                        res.data.data.forEach(item=>{
                            if(item.add_time!=0){
                                item.add_time = this.formatTime(item.add_time * 1000)
                            }else{
                                item.add_time = "";
                            }
                        })
                        this.arrearList = res.data.data;
                        this.dialogVisibleList = true;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                    this.list.forEach(item=>{
                        if(item.id == obj.id){
                        }
                    })                 
                }else{
                    sessionStorage.removeItem("DEMU_ERP_RECEIVABLE_ID")
                    sessionStorage.setItem("DEMU_ERP_RECEIVABLE_ID",obj.id)
                    sessionStorage.removeItem("DEMU_ERP_PAYSUMMARY_TYPE")
                    sessionStorage.setItem("DEMU_ERP_PAYSUMMARY_TYPE",1)
                    this.$root.$children[0].$children[0].addTab({
                        name: '明细详情'+obj.id,
                        label: '明细详情',
                        content: 'componentsReceivableReceivableDetail'
                    });
                }
            },
            getRow(row){
                this.selectRow=row;
            },
            resetSearch(){
                this.params={search:{customer_id: "",salesman_id:""},per_page: 50,page:1,field:"",sort:""}
                this.$refs['selectdowncustomer'].clearData()
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            //表格排序
            sortTable(sort){
                this.params.field = sort.order ? sort.prop:'';
                this.params.sort = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getList();
            },
            //结算 created by xiong
            addSettle(){
                if(this.selectRow.length == 0){
                    this.tip('请选择需要结算客户', 'warning')
                    return
                }
                if(this.selectRow.length > 1){
                    this.tip('不能同时对多个客户进行结算作', 'warning')
                    return
                }
                this.sureDialogVisible = true;
                this.sure_params.amount = this.selectRow[0].debt;
                // let init_balance = this.selectRow[0].init_balance + ''
                // if(init_balance.indexOf('-') == -1){
                //     this.sure_params.amount = init_balance
                // }else{
                //     this.sure_params.amount = init_balance.substr(1)
                // }
            },
            settlement(){
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sure_params.customer_id = this.selectRow[0].id
                    this.sure_params.amount = parseFloat(this.sure_params.amount)
                    this.postFuncLoading("erp/finance.settlement.debt",this.sure_params,()=>{
                        this.tip("结算成功","success")
                        this.sureDialogVisible = false;
                        this.getList()        
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            settlementInput(val){
                    var reg = /(^[1-9][0-9]{0,8}([.][0-9]{0,2})?$)|(^0?(\.[0-9]{0,2})?$)/;
                    if(reg.test(val)){
                        this.sure_params.amount = val;
                    }else{
                        this.sure_params.amount = '';
                    }
            },
            settleClose(){
                this.sure_params.amount = ''
                this.sure_params.remark = ''
            }
            //结算 end
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="进销货款";
                    this.add_params.bill_type=0;
                }
            },
            "initDialogVisible":function(val){
                if(!val){
                    this.initForm=this.resetJson(this.initForm)
                    this.$refs['selectdowncustomer'].clearData()
                }
            },
            "addArrearsDialogVisible":function(val){
                if(!val){
                    this.addArrearsForm=this.resetJson(this.addArrearsForm)
                    this.$refs['selectdowncustomer'].clearData()
                    this.addArrearsTime = new Date();
                }
            }
        }
    }
</script>
